module.exports = __webpack_public_path__ + "media/sfx-opened.e728c0da.ogg";